import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { ComponentPropsWithoutRef } from 'react';
import { WebCategory } from '../../../../../domain/model/category/WebCategory';
import Component from '../components/js/NewsFeedTab';
import { ITopStates } from '../store';
import { actions as feedAction, convertCacheKey, type Action as FeedAction } from '../store/newsFeed';
import { actions as tabAction, type Action as TabAction } from '../store/newsFeedTab';

const mapStateToProps = (state: ITopStates) => {
  return {
    ...state.newsFeedTab,
    stateCache: state.newsFeed.stateCache,
    userToken: state.userToken
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<ITopStates, void, TabAction | FeedAction>) => ({
  fetchFeed: (category: WebCategory, subCategoryId: string, userToken: string | null) => {
    // サブカテfetch
    dispatch(feedAction.fetchFeed(category, subCategoryId, userToken));
  },
  changeTab: (subCategoryId: string, category: WebCategory) => {
    // タブ遷移
    dispatch(tabAction.changeTab(category, subCategoryId));
  },
  reflectStorage() {
    // session storageの情報を反映する
    dispatch(feedAction.reflectSessionStorage);
    // タブにlocalstorageの結果を反映する
    dispatch(tabAction.reflectLocalStorage);
  },
  updateSessionStorage(category: WebCategory, subCategoryId: string) {
    dispatch(feedAction.updateSessionStorage(category, subCategoryId));
  }
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type OwnProps = Omit<ComponentPropsWithoutRef<typeof Component>, keyof StateProps | keyof DispatchProps>;

const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: OwnProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    changeTab: (subCategoryId: string, category: WebCategory) => {
      // タブ遷移
      dispatchProps.changeTab(subCategoryId, category);
      const cacheKey = convertCacheKey(category, subCategoryId);
      const stateCache = stateProps.stateCache;

      if (stateCache[cacheKey]) {
        // cacheがあればsession storageの更新のみ
        dispatchProps.updateSessionStorage(category, subCategoryId);
      } else {
        // cacheがなければfetchする
        dispatchProps.fetchFeed(category, subCategoryId, stateProps.userToken.value);
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component);
